import { motion } from "framer-motion";

const svgProps = { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round", className: "w-10 h-10 text-white overflow-visible" };
const box = { transformBox: "fill-box", transformOrigin: "center" };

export function FoundationIcon() {
  return (
    <motion.svg {...svgProps} initial="hidden" animate="show">
      <motion.path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" style={{ transformBox: "fill-box", transformOrigin: "bottom" }}
        variants={{ hidden: { scaleY: 0, opacity: 0 }, show: { scaleY: 1, opacity: 1, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } } }} />
      <motion.path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" variants={{ hidden: { x: -8, opacity: 0 }, show: { x: 0, opacity: 1, transition: { delay: 0.6, duration: 0.5 } } }} />
      <motion.path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" variants={{ hidden: { x: 8, opacity: 0 }, show: { x: 0, opacity: 1, transition: { delay: 0.7, duration: 0.5 } } }} />
      {[18, 14, 10, 6].map((y, i) => (
        <motion.path key={y} d={`M10 ${y}h4`} stroke="#F5A623" strokeWidth={2}
          variants={{ hidden: { pathLength: 0, opacity: 0 }, show: { pathLength: 1, opacity: 1, transition: { delay: 0.9 + i * 0.15, duration: 0.3 } } }} />
      ))}
      <motion.path d="M12 -3 l1.2 2.4 2.6.4-1.9 1.85.45 2.6L12 3.3l-2.35 1.25.45-2.6L8.2-.2l2.6-.4z" fill="#F5A623" stroke="none" style={box}
        variants={{ hidden: { scale: 0, y: 6, opacity: 0 }, show: { scale: 1, y: 2, opacity: 1, transition: { delay: 1.6, type: "spring", stiffness: 260, damping: 12 } } }} />
    </motion.svg>
  );
}

export function AwardMedalIcon() {
  return (
    <motion.svg {...svgProps} initial="hidden" animate="show">
      <motion.path d="m8.523 12.89-1.514 8.526a.5.5 0 0 0 .81.469l3.586-2.686a1 1 0 0 1 .595-.199V15" style={box}
        variants={{ hidden: { x: -16, y: -14, rotate: -70, opacity: 0 }, show: { x: 0, y: 0, rotate: 0, opacity: 1, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } } }} />
      <motion.path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-.602-.199V15" style={box}
        variants={{ hidden: { x: 16, y: -14, rotate: 70, opacity: 0 }, show: { x: 0, y: 0, rotate: 0, opacity: 1, transition: { duration: 0.8, delay: 0.1, ease: [0.22, 1, 0.36, 1] } } }} />
      <motion.circle cx="12" cy="8" r="6" style={box}
        variants={{ hidden: { scale: 0, opacity: 0 }, show: { scale: 1, opacity: 1, transition: { delay: 0.75, type: "spring", stiffness: 240, damping: 13 } } }} />
      <motion.path d="M12 4.6l1 2.1 2.3.3-1.7 1.6.4 2.3L12 9.8l-2 1.1.4-2.3L8.7 7l2.3-.3z" fill="#F5A623" stroke="none" style={box}
        variants={{ hidden: { scale: 0, rotate: -180, opacity: 0 }, show: { scale: 1, rotate: 0, opacity: 1, transition: { delay: 1.15, type: "spring", stiffness: 200, damping: 12 } } }} />
      <motion.circle cx="12" cy="8" r="6" stroke="#F5A623" strokeWidth={0.8}
        variants={{ hidden: { scale: 1, opacity: 0 }, show: { scale: [1, 1.9], opacity: [0.9, 0], transition: { delay: 1.2, duration: 0.9 } } }} style={box} />
    </motion.svg>
  );
}

export function HandshakeIcon() {
  return (
    <motion.svg {...svgProps} initial="hidden" animate="show">
      <motion.g style={box} variants={{ hidden: { rotate: 0 }, show: { rotate: [0, 0, -7, 7, -6, 6, -3, 0], transition: { delay: 0.9, duration: 1.1, times: [0, 0.05, 0.2, 0.4, 0.55, 0.7, 0.85, 1] } } }}>
        <motion.g variants={{ hidden: { x: -14, opacity: 0 }, show: { x: 0, opacity: 1, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } } }}>
          <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
          <path d="M3 4h8" />
        </motion.g>
        <motion.g variants={{ hidden: { x: 14, opacity: 0 }, show: { x: 0, opacity: 1, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } } }}>
          <path d="m11 17 2 2a1 1 0 1 0 3-3" />
          <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
          <path d="m21 3 1 11h-2" />
        </motion.g>
      </motion.g>
      {[[-1, -1], [1, -1.2], [0, -1.6]].map(([dx, dy], i) => (
        <motion.circle key={i} cx={12 + dx * 3} cy={2 + dy} r="0.7" fill="#F5A623" stroke="none"
          variants={{ hidden: { opacity: 0, scale: 0 }, show: { opacity: [0, 1, 0], scale: [0, 1.4, 0], y: [0, -3, -5], transition: { delay: 1.0 + i * 0.12, duration: 0.7 } } }} />
      ))}
    </motion.svg>
  );
}

export function GlobeExpandIcon() {
  return (
    <motion.svg {...svgProps} initial="hidden" animate="show">
      <motion.circle cx="12" cy="12" r="10" variants={{ hidden: { pathLength: 0, opacity: 0 }, show: { pathLength: 1, opacity: 1, transition: { duration: 0.9, ease: "easeInOut" } } }} />
      <motion.path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" strokeOpacity={0.6} variants={{ hidden: { pathLength: 0, opacity: 0 }, show: { pathLength: 1, opacity: 1, transition: { delay: 0.6, duration: 0.7 } } }} />
      <motion.path d="M2 12h20" strokeOpacity={0.6} variants={{ hidden: { pathLength: 0, opacity: 0 }, show: { pathLength: 1, opacity: 1, transition: { delay: 0.8, duration: 0.5 } } }} />
      <motion.path d="M16.5 15.5 Q 12 6 7.5 9" stroke="#F5A623" strokeDasharray="1.2 1.4" strokeWidth={1.2}
        variants={{ hidden: { pathLength: 0, opacity: 0 }, show: { pathLength: 1, opacity: 1, transition: { delay: 1.5, duration: 0.9, ease: "easeInOut" } } }} />
      <motion.g style={box} variants={{
        hidden: { x: 4.5, y: 3.5, scale: 0, opacity: 0 },
        show: { x: [4.5, 4.5, 1.5, -4.5], y: [3.5, 3.5, -5, -3], scale: [0, 1, 1, 1.2], opacity: 1, transition: { delay: 1.2, duration: 1.4, times: [0, 0.25, 0.65, 1], ease: "easeInOut" } },
      }}>
        <path d="M12 6.5a3 3 0 0 1 3 3c0 2.2-3 5-3 5s-3-2.8-3-5a3 3 0 0 1 3-3z" fill="#E8842C" stroke="#fff" strokeWidth={1.2} />
        <circle cx="12" cy="9.5" r="1" fill="#fff" stroke="none" />
      </motion.g>
      <motion.circle cx="7.5" cy="9" r="1.2" fill="#F5A623" stroke="none" style={box}
        variants={{ hidden: { scale: 0, opacity: 0 }, show: { scale: [0, 2.4], opacity: [0.9, 0], transition: { delay: 2.5, duration: 0.8 } } }} />
    </motion.svg>
  );
}
